import * as React from 'react';
import { IssueTypes } from '../../components/Accessibility/constants';

const IssueSeverityIcon = ({ severity = IssueTypes.CRITICAL, ...props }) => {
  switch (severity) {
    case IssueTypes.CRITICAL:
      return (
        <svg
          width={16}
          height={16}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path d="M3 12L7.66667 4L12.3333 12H3Z" fill="#CF222E" />
        </svg>
      );
    case IssueTypes.SERIOUS:
      return (
        <svg
          width={16}
          height={16}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <rect x={4} y={4} width={8} height={8} fill="#8250DF" />
        </svg>
      );
    case IssueTypes.MODERATE:
      return (
        <svg
          width={16}
          height={16}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <circle cx={8} cy={8} r={4} fill="#0969DA" />
        </svg>
      );
    case IssueTypes.MINOR:
      return (
        <svg
          width={16}
          height={16}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <circle cx={8} cy={8} r={3.25} stroke="#333333" strokeWidth={1.5} />
        </svg>
      );
    default:
      return;
  }
};

export default IssueSeverityIcon;
